/**
 * Represents supported temporal units
 *
 * @type {Object<string>}
 */
const TemporalUnit = {
    MINUTE: 'minute',
    HOUR: 'hour',
    DAY: 'day',
    WEEK: 'week',
    YEAR: 'year'
};

export default TemporalUnit;
